export const styles = (theme) => ({
  containerDetail: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing(3),
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  labelDetail: {
    color: "#263238",
    display: "block",
    fontWeight: "500",
    fontSize: "1rem",
    fontWeight: "500",
    lineHeight: "20px",
    letterSpacing: "-0.05px",
    marginBottom: "0.5rem",
  },
  rootListDetail: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  textDetail: {
    display: 'inline',
  },
  containerButton: {
    display: "flex",
    marginLeft: "1rem",
  },
  buttonActive: {
    color: "#fff",
    backgroundColor: "#007bff",
    // borderRight: 'none',
    border: "none",
    borderRadius: "unset",
  },
  buttonNonActive: {
    // borderRight: 'none',
    border: "none",
    borderRadius: "unset",
  },
});
